module.exports = __webpack_public_path__ + "static/media/filerequest.3456f6d0.gif";